//  @flow
import * as React from "react";
import * as Actions from "actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AdminMainSubscriptionSearch    from "components/pages/admin/subscriptions/AdminMainSubscriptionSearch";

import { checkUserAllowed } from "helpers/utils.js";

import "./styles.scss";
import {Box, Typography} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {useState} from "react";




function TabPanel(props) {
    const {
        children, value, index, ...other
    } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const AdminSubscriptions = (props) => {

  const {
    userDetails
  } = props;

  const getActiveTabInitial = () => {

      if (checkUserAllowed(userDetails.userlevel, "newsubscriptions")) {
          return 0;
      } else if (checkUserAllowed(userDetails.userlevel, "pendingpayment")) {
          return 1;
      } else if (checkUserAllowed(userDetails.userlevel, "subscriptionsnearby")) {
          return 2;
      } else {
          return 0;
      }
  }

    const [value, setValue] = useState(getActiveTabInitial());

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

  const renderCategories = () => {
    if (checkUserAllowed(userDetails.userlevel, "newsubscriptions")) {
      return (
          <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs value={value}
                        onChange={handleChange}
                        variant="fullWidth"
                        aria-label="">
                      {checkUserAllowed(userDetails.userlevel, "newsubscriptions") &&
                          <Tab label="Pending" {...a11yProps(0)} />
                      }
                      {checkUserAllowed(userDetails.userlevel, "pendingpayment") &&
                          <Tab label="Ready" {...a11yProps(1)} />
                      }
                      {checkUserAllowed(userDetails.userlevel, "subscriptionsnearby") &&
                          <Tab label="Nearby" {...a11yProps(2)} />
                      }

                  </Tabs>
              </Box>
              { checkUserAllowed(userDetails.userlevel, "newsubscriptions") &&
                  <TabPanel value={value} index={0}>
                      <AdminMainSubscriptionSearch {...props} shopsearchtype="new" ></AdminMainSubscriptionSearch>
                  </TabPanel>
              }
              { checkUserAllowed(userDetails.userlevel, "pendingpayment") &&
                  <TabPanel value={value} index={1}>
                      <AdminMainSubscriptionSearch {...props} shopsearchtype="due" ></AdminMainSubscriptionSearch>
                  </TabPanel>
              }
              <TabPanel value={value} index={2}>
                  <AdminMainSubscriptionSearch {...props} shopsearchtype="nearby" ></AdminMainSubscriptionSearch>
              </TabPanel>

          </Box>
      )
    } else {
      return (
          <div>Not available </div>
      )
    }
  }

  return (
      <div>
        {
          renderCategories()
        }
      </div>
  );
}

const adminSubscriptions = connect(
    ({ bootupInfo }) => ({
      bootupInfo,
      userDetails: bootupInfo.userDetails,
    }),
    (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminSubscriptions);

export { adminSubscriptions as default };

